import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda} from "@commons/core.slice";
import AziendaNavContainer from "../../../features/azienda/AziendaNavContainer";
import {useQueryFilter, useSetIdAziendaTabelle} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";
import {CreateButton, useEditor} from "../../../core/editor";
import {Tab} from "@headlessui/react";
import DTTitle from "../../../components/dataTable/TableTitle";
import DTTable from "../../../components/dataTable/Table";
import Pagination from "../../../components/dataTable/Pagination";
import React, {useCallback, useMemo, useState} from "react";
import {
    useDeleteElementoMutation,
    useGetAziendaTabellaElementiRMLQuery,
    useInsertElementoMutation,
    useLazyGetElementoQuery,
    useUpdateElementoMutation
} from "@commons/features/azienda/tabelle/aziendaTabelle.api";
import {useFactory} from "@commons/utils/useFactory";
import ElementiRMLXTabellaPage from "./ElementiRMLXTabella.page";
import {IdAziendaParams} from "@commons/utils/APIParams";
import * as Buttons from "../../../components/dataTable/buttons";
import AziendaTabelleEditor from "../aziendaTabelle.editor";
import {CentroDiCostoRecord, TabellaElementiRMLRecord} from "@commons/mapping/CentroDiCostoRecord";

const TabelleRetributivePage: React.FC<{}> = () => {
    const [tabIndex, setTabIndex] = useState<number>(0);
    //const aziendaMaster = useAppSelector(selectAziendaMaster);
    const azienda = useAppSelector(selectAzienda);
    /*
        useEffect(() => {
            cancel();
        }, [azienda ? azienda.idAziendaCDIC : 0])
    */

    const [getTrigger, result, promiseInfo] = useLazyGetElementoQuery();
    const [insertTrigger, insertResult] = useInsertElementoMutation();
    const [updateTrigger, updateResult] = useUpdateElementoMutation();
    const [deleteTrigger, deleteResult] = useDeleteElementoMutation();
    const {
        resource,
        create,
        cancel,
        URI,
        loadResource,
        saveResource,
        deleteResource,
        editorState
    } = useEditor<TabellaElementiRMLRecord>(insertTrigger, getTrigger, updateTrigger, deleteTrigger)

    const pagination = usePagination('',1, 10);
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;

    const {filter, setFilter, skip} = useQueryFilter<IdAziendaParams>({} as IdAziendaParams, pagination);
    useSetIdAziendaTabelle(azienda, setFilter, useCallback(() => {
        cancel();
        setTabIndex(0);
    }, [cancel]));

    const {data} = useGetAziendaTabellaElementiRMLQuery(filter, {skip: skip || !filter.idAzienda});

    const localData = data;

    //const defaultValues = useFactory(CentroDiCostoRecord.factory, {idAzienda: filter.idAzienda!, idTipo: 50});
    // E' preferibile l'uso di useMemo, così da non istanziare ogni volta un nuovo defaultValues
    const params = useMemo(() => {
        return {idAzienda: filter.idAzienda!, idTipo: 50};
    }, [filter.idAzienda]);
    const defaultValues = useFactory(CentroDiCostoRecord.factory, params);

    return (<>
        <AziendaNavContainer>

            <div className="px-2 py-3 bg-gray-200 rounded-lg">
                <div className="m-2">
                    <div className="relative">
                        {tabIndex === 0 && <div className="absolute right-2">
                            <CreateButton<TabellaElementiRMLRecord> create={create} label="Tabella"/>
                        </div>}
                    </div>
                    <Tab.Group selectedIndex={tabIndex} onChange={(index) => setTabIndex(index)}>
                        <Tab.List className="tab-list">
                            <Tab className="tab">Propriet&agrave;</Tab>
                            <Tab disabled={URI === null} className="tab">Elementi retributivi</Tab>
                        </Tab.List>
                        <Tab.Panels className="tab-panels">
                            <Tab.Panel unmount={false}> {/* unmount permette di NON distruggere il tab ogni volta che si cambia tab!!! */}
                                {resource && <div className="p-3">
                                    <p className="text-xs">URI: {URI}</p>
                                    <AziendaTabelleEditor
                                        defaultValues={defaultValues}
                                        resource={resource}
                                        onSubmit={saveResource}
                                        onCancel={cancel}></AziendaTabelleEditor>
                                </div>}
                            </Tab.Panel>
                            <Tab.Panel unmount={false} className="p-3">
                                {resource && (URI || editorState === 'update') && <div className="p-3">
                                    <p className="text-xs">URI: {URI}</p>
                                    <ElementiRMLXTabellaPage
                                        master={resource}
                                    />
                                </div>}
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div>

            <DTTitle id="elencoTabelle" title="Combinazioni per azienda degli elementi RML" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

            <DTTable<TabellaElementiRMLRecord> dtSchema={localData}
                                               header={<>
                                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                               Codice
                                                           </th>
                                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                               Descrizione
                                                           </th>
                                                           <th scope="col" className="py-3.5 w-14"/>
                                                       </>}

                                               rows={({item, index, isMobile, currentRow, register}) => (
                                                           <tr {...register(item.id!, index, item.URI === URI)}>
                                                               <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                                                   {item.id}
                                                               </td>

                                                               <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                                                   {item.descrizione}
                                                               </td>

                                                               <td className="align-middle text-sm font-medium">
                                                                   <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                                       <Buttons.Edit onAction={() => loadResource(item.URI)}/>
                                                                       <Buttons.Delete onConfirm={() => {
                                                                           deleteResource(item.URI!)
                                                                       }}/>
                                                                   </Buttons.Visibility>
                                                               </td>
                                                           </tr>)
                                                       }
            />

            <Pagination dataTables={localData} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>

        </AziendaNavContainer>
    </>)
}
export default TabelleRetributivePage;